// extracted by mini-css-extract-plugin
export var center = "_1t-2";
export var clickableRow = "_1t-5";
export var expandedRow = "_1t-7";
export var hoverable = "_1t-4";
export var left = "_1t-1";
export var right = "_1t-3";
export var row = "_1t-0";
export var selectedRow = "_1t-6";
export var summaryRow = "_1t-8";